module.exports = __webpack_public_path__ + "media/images/aboutUA-76e83f1d.png";